var _rect, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCallMade(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("mask", {
    id: "mask0_7425_205153",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 16,
    height: 16
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "#D9D9D9"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_7425_205153)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M3.15039 12.8336C3.00586 12.6891 2.93359 12.5224 2.93359 12.3336C2.93359 12.1443 3.00586 11.9776 3.15039 11.8336L10.2496 4.73362H6.66639C6.47759 4.73362 6.31386 4.66402 6.17519 4.52482C6.03599 4.38615 5.96639 4.22242 5.96639 4.03362C5.96639 3.84482 6.03599 3.68082 6.17519 3.54162C6.31386 3.40295 6.47759 3.33362 6.66639 3.33362H11.9504C12.1392 3.33362 12.3029 3.40295 12.4416 3.54162C12.5803 3.68082 12.6496 3.84482 12.6496 4.03362V9.31682C12.6496 9.50562 12.5803 9.66935 12.4416 9.80802C12.3029 9.94722 12.1392 10.0168 11.9504 10.0168C11.7611 10.0168 11.5971 9.94722 11.4584 9.80802C11.3192 9.66935 11.2496 9.50562 11.2496 9.31682V5.71682L4.11679 12.8496C3.97226 12.9942 3.80826 13.0608 3.62479 13.0496C3.44186 13.039 3.28373 12.967 3.15039 12.8336Z",
    fill: "#587E85"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCallMade);
export default __webpack_public_path__ + "static/media/call_made.a45fa7dcc1ff23b03d31a6df00ecdedf.svg";
export { ForwardRef as ReactComponent };